import React, { useEffect, useState } from 'react';
import MuiDataTable from "../../../components/muidatatable";
import * as BusinessConst from "../../../utils/businessconstants"
import { Typography, Stack, Container, Box, Card, CardContent } from "@mui/material";
import { getAPI } from "../../../services/basehttpAPI";
import MuiSearch from "../../../components/muisearch";

const ShipToPartyList = () => {
  const translatedText = JSON.parse(sessionStorage.getItem("TranslationText"));
  const [shipToPartyList, setShipToPartyList] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [dataList, setFilteredData] = useState([]);
  useEffect(() => {
    getShipToPartyList();
  }, []);
  useEffect(() => {
    filterData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue]);

  const filterData = () => {
    if (searchValue !== "") {
      const filteredList = shipToPartyList.filter((item) => {
        return (
          item.shipToName?.toLowerCase().includes(searchValue.toLowerCase()) ||
          item.customShipToName?.toLowerCase().includes(searchValue.toLowerCase()) ||
          item.shiptoId?.toLowerCase().includes(searchValue.toLowerCase())
        );
      });
      setFilteredData(filteredList);
    }
    else {
      setFilteredData(shipToPartyList);
    }
  };
  const getShipToPartyList = async () => {
    let url = "ShipToParty/GetAllShipToParty";
    const response = await getAPI(url, null);
    setShipToPartyList(response?.responseData);
    setFilteredData(response?.responseData);
  };
  const columnHeaders = [
    { id: "id", label: "#", align: "left", enableSort: true },
    { id: "shiptoId", label: translatedText.ship_to_id, align: "left", enableSort: true },
    {
      id: "shipToName",
      label: translatedText.ship_to_name,
      align: "left",
      enableSort: true,
      style: "bold",
    },
    {
      id: "customShipToName",
      label: translatedText.custom_ship_to_name,
      align: "left",
      enableSort: true,
    },
    { id: "action", label: "action", align: "left", pagekey: BusinessConst.pagekey_viewcustomshiptoparty, enableSort: false, },
  ];
  return (
    <>
      <Container maxWidth="xl" sx={{ width: "100%" }}>
        <Stack direction="row" spacing={2} paddingBottom={"30px"}>
          <Typography variant="h5" flexGrow={1}>
            {translatedText?.shiptoparty_list}
          </Typography>
        </Stack>
        <Box>
          <MuiSearch callback={(searchValue) => setSearchValue(searchValue)} />
          {
            (dataList?.length === 0) ?
              (
                <Card>
                  <CardContent>
                    <Typography variant="h6" align="center" component="div">
                      {translatedText.no_records_found}
                    </Typography>
                  </CardContent>
                </Card>
              )
              : (
                <MuiDataTable headerdata={columnHeaders} rowData={dataList} />
              )
          }
        </Box>
      </Container>
    </>
  )
};
export default ShipToPartyList;